import { paginationSchema } from '~/components/Pagination/Pagination.schema';
import { formatDate, startOfYear } from '~/utils/date';
import { z } from 'zod';

export const querySchema = z
  .object({
    competition_type_id: z
      .string()
      .transform(v => (v ? Number(v) : undefined))
      .default('1'),
    age_category_id: z
      .string()
      .transform(v => (v ? Number(v) : undefined))
      .optional(),
    weight_class_id: z
      .string()
      .transform(v => (v ? Number(v) : undefined))
      .optional(),
    from_date: z.string().optional().default(formatDate(startOfYear(), 'yyyy-mm-dd')),
    discipline: z.string().optional().default('points'),
    sex: z.enum(['ALL', 'F', 'M']).default('ALL'),
    to_date: z.string().optional(),
  })
  .merge(paginationSchema);

export type QuerySchema = z.infer<typeof querySchema>;
